<template>
  <div>
    <RF-Aba :cpntButtons='buttons'></RF-Aba>
  </div>
</template>

<style>
  div > .rf-config-tab {
    width: 100%;
  }
</style>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba.vue')
    },
    data: function () {
      return {
        buttons: []
      }
    },
    mounted: function () {
      // TELA DE CONFIGURAÇÕES DE VENDAS/ORÇAMENTOS
      this.buttons.push({ nome: 'Vendas', router: this.$router.resolve({ name: 'venda_config_cs', params: { cts: this.$store.state.token.cts, nome: 'venda_conf_ven' } }).href, aRouterSelect: [] })

      // TELA DE CONFIGURAÇÕES DO RECIBO DE VENDA
      this.buttons.push({ nome: 'Ordem de Serviço', router: this.$router.resolve({ name: 'venda_config_cs', params: { cts: this.$store.state.token.cts, nome: 'venda_conf_os' } }).href, aRouterSelect: [] })

      // TELA DE CONFIGURAÇÕES DA RECORRENCIA
      this.buttons.push({ nome: 'Recorrências', router: this.$router.resolve({ name: 'venda_config_cs', params: { cts: this.$store.state.token.cts, nome: 'venda_conf_age' } }).href, aRouterSelect: [] })

      // TELA DE CONFIGURAÇÕES DE CONTROLE DE PROCESSO
      if (this.$store.state.pcoAntigo === false && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 11 ], null, null, null, null, null, false) === true) {
        this.buttons.push({ nome: 'Controle de Processos', router: this.$router.resolve({ name: 'venda_config_cs', params: { cts: this.$store.state.token.cts, nome: 'venda_conf_pco' } }).href, aRouterSelect: [] })
      }

      // TELA DE CONFIGURAÇÕES DO INTERMEDIADOR
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 23, 20 ], 'or', null, null, null, null, false) === true) {
        this.buttons.push({ nome: 'Intermediador', router: this.$router.resolve({ name: 'venda_config_intermediador', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'venda_config_intermediador' ] })
      }
    }
  }
</script>
